<template lang="pug">
  #ItemsListIndex.container-width
    h5.text-center.py-3.letter-spacing-6 我的工作管理
    hr.border.border-primary.w-100
    .p-3.bg-light
      b-card.rounded-0.border-0(
        bg-variant="light",
        v-for="(router,index) in routers",
        :key="index",
        body-class="p-0"
      )
        router-link(
          :to="{name: router.routerPushName ? router.routerPushName : 'sa-items-list-index'}"
        )
          .row.no-gutters.p-3(
            :class="{ 'border-top border-primary': index !== 0 }"
          )
            .col-2.pr-1.text-center
              //- Use Font Awesome Icon
              //- i.fa-lg(
              //-   :class="router.iconClassName",
              //-   style="font-size: 1.5rem;color: #000000;"
              //- )
              b-img(
                :src="router.iconClassName",
                fluid,
                alt="Icon",
                width="35",
                height="35"
              )
            .col-10.pl-1.d-flex.align-items-center
              span(
                style="color: #000000;"
              ) {{ router.name }}
</template>

<script>
import { SA_MSG_MANAGER_INDEX } from '@/router/sa/msg-manager';
import { SA_RESERVATION_INDEX } from '@/router/sa/reservation';
import { SA_CONTACTS_INDEX } from '@/router/sa/contacts';
import { SA_LABEL_INDEX } from '@/router/sa/label';
import { SA_PROFILE_INDEX } from '@/router/sa/profile';
import { SA_QR_CODE_INDEX } from '@/router/sa/qr-code';

import IconMsgManagerUrl from '@/assets/images/icon/icon_msg_manager.png';
import IconReservationUrl from '@/assets/images/icon/icon_reservation.png';
import IconContactsUrl from '@/assets/images/icon/icon_contacts.png';
import IconLabelUrl from '@/assets/images/icon/icon_label.png';
import IconProfileUrl from '@/assets/images/icon/icon_profile.png';
import IconQRCodeUrl from '@/assets/images/icon/icon_qrcode_solid.png';

export default {
  name: 'ItemsListIndex',
  data() {
    return {
      routers: [
        {
          name: '訊息管理',
          iconClassName: IconMsgManagerUrl,
          routerPushName: SA_MSG_MANAGER_INDEX
        },
        {
          name: '我的預約',
          iconClassName: IconReservationUrl,
          routerPushName: SA_RESERVATION_INDEX
        },
        {
          name: '我的客戶',
          iconClassName: IconContactsUrl,
          routerPushName: SA_CONTACTS_INDEX
        },
        {
          name: '客戶標籤',
          iconClassName: IconLabelUrl,
          routerPushName: SA_LABEL_INDEX
        },
        {
          name: '修改個人資料',
          iconClassName: IconProfileUrl,
          routerPushName: SA_PROFILE_INDEX
        },
        {
          name: 'CA qr-code',
          iconClassName: IconQRCodeUrl,
          routerPushName: SA_QR_CODE_INDEX,
          isShow: true
        }
      ]
    };
  },
  mounted() {
    this.$store.commit('toggleLoading', false);
  }
};
</script>

<style>

</style>
